import React from 'react';
import fetchLocationProfileList from '@testnotify/core/api/fetch-location-profile-list';
import injectSheet from 'react-jss';
import root from 'window-or-global';

// Components
import Page from '../components/Page';
import SectionTitle from '../components/SectionTitle';
import IdentifierBacklogForm from '../components/IdentifierBacklogForm';
import Head from 'next/head';

interface Props {
  classes: any;
  testLocations: any;
}

class IdentifierBacklogPage extends React.PureComponent<Props> {
  static async getInitialProps(ctx) {
    return fetchLocationProfileList()
      .then(({ locationProfiles }) => {
        return {
          testLocations: locationProfiles,
        };
      })
      .catch(error => {
        return {
          testLocations: undefined,
        };
      });
  }

  render() {
    const { classes, testLocations } = this.props;

    return (
      <>
        <Head>
          <title>Identifier Backlog - TestNotify</title>
          {
            // @ts-ignore
            <link rel="stylesheet" href="/static/css/date-range-picker.css" async />
          }
          {
            // @ts-ignore
            <link rel="stylesheet" href="/static/css/date-range-picker-override.css" async />
          }

          <meta
            name="description"
            content="Purchase testing center data from past court order test."
          />
        </Head>
        <Page classes={{ children: classes.root }}>
          <SectionTitle
            title="Identifier Backlog"
            subheader="Purchase Test Center identifier logs over a range of dates."
          />
          <div className={classes.form}>
            <IdentifierBacklogForm testLocations={testLocations} />
          </div>
        </Page>
      </>
    );
  }
}

const styles = theme => {
  return {
    root: {
      maxWidth: theme.widths.content + 250, // 250 compensates for date-range component
      flexDirection: 'column',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
    },
    form: {
      maxWidth: theme.widths.form,
    },
  };
};

export default injectSheet(styles)(IdentifierBacklogPage);
